// This is the modal for EEBDMainBuildingRoofExtendedDataModal.

import { Component, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eebd-main-building-roof-extended-data-modal',
  templateUrl: './eebd-main-building-roof-extended-data-modal.component.html',
})
export class EEBDMainBuildingRoofExtendedDataModalComponent implements OnInit {
  bdMainBuildingExtendedRoofDetails: any[] = [{}];
  @Input() isEdit: boolean;
  @Input() buildingPartNumber: number;
  @Input() buildingRoofExtendedDataDetails: any;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    if(this.buildingPartNumber === this.buildingRoofExtendedDataDetails.buildingPartNumber) {
      this.bdMainBuildingExtendedRoofDetails.forEach(detail => {
        detail.flatCeilingOneArea = this.buildingRoofExtendedDataDetails.flatCeilingOneArea || null,
        detail.flatCeilingOneUValue = this.buildingRoofExtendedDataDetails.flatCeilingOneUValue || null,
        detail.flatCeilingTwoArea = this.buildingRoofExtendedDataDetails.flatCeilingTwoArea || null,
        detail.flatCeilingTwoUValue = this.buildingRoofExtendedDataDetails.flatCeilingTwoUValue || null,
        detail.slopeOneArea = this.buildingRoofExtendedDataDetails.slopeOneArea || null,
        detail.slopeOneUValue = this.buildingRoofExtendedDataDetails.slopeOneUValue || null,
        detail.slopeTwoArea = this.buildingRoofExtendedDataDetails.slopeTwoArea || null,
        detail.slopeTwoUValue = this.buildingRoofExtendedDataDetails.slopeTwoUValue || null,
        detail.studWallOneArea = this.buildingRoofExtendedDataDetails.studWallOneArea || null,
        detail.studWallOneUValue = this.buildingRoofExtendedDataDetails.studWallOneUValue || null,
        detail.studWallTwoArea = this.buildingRoofExtendedDataDetails.studWallTwoArea || null,
        detail.studWallTwoUValue = this.buildingRoofExtendedDataDetails.studWallTwoUValue || null,
        detail.gableWallOneArea = this.buildingRoofExtendedDataDetails.gableWallOneArea || null,
        detail.gableWallOneUValue = this.buildingRoofExtendedDataDetails.gableWallOneUValue || null,
        detail.gableWallTwoArea = this.buildingRoofExtendedDataDetails.gableWallTwoArea || null,
        detail.gableWallTwoUValue = this.buildingRoofExtendedDataDetails.gableWallTwoUValue || null
      });
    }
  }
  
  onClose(): void {
    if (this.bdMainBuildingExtendedRoofDetails) {
      let bdMainBuildingExtendedRoofRow;
      this.bdMainBuildingExtendedRoofDetails.forEach((detail) => {
        bdMainBuildingExtendedRoofRow = {
          buildingPartNumber: detail.buildingPartNumber,
          flatCeilingOneArea: detail.flatCeilingOneArea || null,
          flatCeilingOneUValue: detail.flatCeilingOneUValue || null,
          flatCeilingTwoArea: detail.flatCeilingTwoArea || null,
          flatCeilingTwoUValue: detail.flatCeilingTwoUValue || null,
          slopeOneArea: detail.slopeOneArea || null,
          slopeOneUValue: detail.slopeOneUValue || null,
          slopeTwoArea: detail.slopeTwoArea || null,
          slopeTwoUValue: detail.slopeTwoUValue || null,
          studWallOneArea: detail.studWallOneArea || null,
          studWallOneUValue: detail.studWallOneUValue || null,
          studWallTwoArea: detail.studWallTwoArea || null,
          studWallTwoUValue: detail.studWallTwoUValue || null,
          gableWallOneArea: detail.gableWallOneArea || null,
          gableWallOneUValue: detail.gableWallOneUValue || null,
          gableWallTwoArea: detail.gableWallTwoArea || null,
          gableWallTwoUValue: detail.gableWallTwoUValue || null,
        }
      });
    }
    this.activeModal.close(this.bdMainBuildingExtendedRoofDetails);
  }

}
